import React from "react";
import Pill from "../../../../../shared/Pill/Pill";

const AdvancedManagementPills = props => {
	return (
		<div className="advanced-management-home__pills">
			{props.arrayTypes.map(
				item =>
					item.value !== 0 &&
					item.results > 0 && (
						<Pill
							key={item.value}
							className={`advanced-management-home__pills__button`}
							selected={props.status == item.value}
							onClick={() => props.handleClick(item)}
						>
							{item.label}
						</Pill>
					)
			)}
		</div>
	);
};

export default AdvancedManagementPills;
